import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetBillsRequestModel, GetBillsResponse } from '@app/models/get-bills.model';
import { ChecksCashNow, UserCashNow, UserCashNowResponse } from '@app/models/userCashNow.model';
import { UserModel } from '@app/models/user.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CashNowService {

  public apiUrl: string
  public headers: HttpHeaders = new HttpHeaders();
  public identity: UserModel;
  public cashNowToken: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.urlApiCY;
    this.cashNowToken = environment.cashNowApiKey;
    this.headers = this.getBasicAuthorization();
    this.getIdentity();
  }

  getBasicAuthorization(): HttpHeaders {
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set(
        "Authorization",
        `Basic ${btoa(this.cashNowToken)}`
      );
    return headers;
  }

  getIdentity() {
    this.identity = UserModel.fromResponse(JSON.parse(sessionStorage.getItem('user')));

    return {
      "tipoDocumento": this.identity.userInfo.documentType,
      "numeroDocumento": this.identity.userInfo.document
    };
  }

  validateUserStatusCashNow(body: UserCashNowResponse, addUser: boolean): Observable<boolean> {
    const options = { headers: this.headers };

    return this.http.post<UserCashNow>(`${this.apiUrl}/user/afiliado-cajaya`, body, options)
      .pipe(
        map(res => {
          !addUser && sessionStorage.setItem("cajaYa", res.data.cajaYa.toString());
          return res.data.cajaYa;
        })
      );
  }

  updateUserStatusCashNow(body: UserCashNowResponse): Observable<UserCashNow> {
    const options = { headers: this.headers };

    return this.http.post<UserCashNow>(`${this.apiUrl}/user/afiliado-cajaya-update-state`,
      body, options
    );
  }

  getBills(getBillsRequestModel: GetBillsRequestModel): Observable<number> {
    const options = { headers: this.headers };

    return this.http.post<GetBillsResponse>(`${this.apiUrl}/facturas/filter`, getBillsRequestModel, options)
      .pipe(
        map((response: GetBillsResponse) => response.data.cantidadFacturasCheck)
      );
  }

  deleteCheckedBills(): Observable<ChecksCashNow> {
    const options = { headers: this.headers };

    return this.http.post<ChecksCashNow>(`${this.apiUrl}/facturas/logout`,
      this.getIdentity(), options
    );
  }

}
